import EnergyList from './views/energy-list.c';
export default EnergyList;
